import React from 'react'
import { StringSelect } from './ItemSelect'
import { keyTest } from 'shared/utils'

export function CrosswalkStatusColumn<T extends { id: number }>({
  item,
  columnData: { key: updateKey },
}: {
  item: T
  columnData: { key: string }
}) {
  const currentValue = keyTest(item, updateKey) ? (item[updateKey] ?? '') : ''
  return (
    <StringSelect
      setKey={updateKey}
      items={['active', 'inactive']}
      initialItem={String(currentValue)}
    />
  )
}
